// eslint-disable-next-line no-shadow
export enum BRAND {
  HOTPADS = 'hotpads',
  ZILLOW = 'zillow',
}
